import { useTranslation } from 'react-i18next';
import { Table, Spin, Tag } from 'antd';
import GlobalService from '../../../../services/Global.service';
import { LoadingOutlined } from '@ant-design/icons';

export default function ImportHistory({
    result,
    onPageChange,
    paginationProps,
    loadingTable,
}) {
    const { t, i18n } = useTranslation(['import-department']);

    const getTagStatus_ = (type) => {
        switch (type) {
            case 'Finished':
                return (
                    <Tag className="rounded-xl text-[#1890FF] border-[#1890FF] bg-white -my-1 font-medium">
                        {i18n.language === 'en' ? type : type}
                    </Tag>
                );
            case 'Failed':
                return (
                    <Tag className="rounded-xl text-[#F0536F] border-[#F0536F] bg-white -my-1 font-medium">
                        {i18n.language === 'en' ? type : type}
                    </Tag>
                );
            case 'Uploading':
                return (
                    <Tag className="rounded-xl text-[#ff932d] border-[#ff932d] bg-white -my-1 font-medium">
                        {i18n.language === 'en' ? type : type}{' '}
                        <LoadingOutlined spin />
                    </Tag>
                );
            default:
                return (
                    <Tag className="rounded-xl text-[#F0536F] border-[#F0536F] bg-white -my-1 font-medium">
                        {i18n.language === 'en' ? type : type}
                    </Tag>
                );
        }
    };

    const downloadFile = async (value, row) => {
        try {
            // const res = ImportConsentService.DownloadTemplateId(row?.fileStorageId);
            const res = await GlobalService.downloadDoc(row?.fileStorageId);
            console.log(res);
            const objectURL = window.URL.createObjectURL(new Blob([res?.data]));
            const link = document.createElement('a');
            const filename = value;
            link.href = objectURL;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
        } catch (error) {
            console.log(error);
        }
    };

    const columns = [
        {
            title: t('Import Date'),
            dataIndex: 'importDate',
            key: 'importDate',
            sorter: true,
            render: (value) => {
                return (
                    <div className="text-[#65707A] font-semibold">
                        {value ? <div>{value}</div> : <>-</>}
                    </div>
                );
            },
        },
        {
            title: t('File name'),
            dataIndex: 'fileName',
            key: 'fileName',
            sorter: true,
            render: (value, row, index) => {
                return (
                    <>
                        <div className="flex items-center">
                            <span className="px-2"></span>
                            {row?.isDownload && row?.status !== 'Uploading' ? (
                                <>
                                    <span
                                        onClick={() => {
                                            downloadFile(value, row);
                                        }}
                                        className="text-sm cursor-pointer text-[#1890FF] font-semibold"
                                    >
                                        {value}
                                    </span>
                                </>
                            ) : (
                                <>
                                    <span className="text-sm font-semibold text-[#65707A]">
                                        {value}
                                    </span>
                                </>
                            )}
                        </div>
                    </>
                );
            },
        },
        {
            title: t('Result'),
            dataIndex: 'result',
            key: 'result',
            sorter: false,
            render: (value) => {
                return (
                    <div className="text-[#65707A] font-semibold">
                        {value ? <div>{value}</div> : <>-</>}
                    </div>
                );
            },
        },
        {
            title: t('User'),
            dataIndex: 'user',
            key: 'user',
            // with: 154,
            sorter: false,
            render: (value) => {
                return (
                    <div className="text-[#65707A] font-semibold">
                        {value ? <div>{value}</div> : <>-</>}
                    </div>
                );
            },
        },
        {
            title: t('Status'),
            dataIndex: 'status',
            key: 'status',
            width: '10%',
            align: 'center',
            sorter: false,
            render: (value, row, index) => {
                return (
                    <>
                        <span className="px-2 text-center">
                            {getTagStatus_(value)}
                        </span>
                    </>
                );
            },
        },
    ];

    return (
        <>
            <div className="text-xl font-medium">{t('Import History')}</div>
            <div className="text-[13px] text-[#B5B5C3]">
                {t('Import sessions are kept for 7 days')}
            </div>
            <Spin spinning={!result}>
                <>
                    <div className="mt-6 mb-10">
                        <Table
                            onChange={onPageChange}
                            rowKey={(record) => record.fileStorageId}
                            className="inbox_table"
                            dataSource={result}
                            columns={columns}
                            pagination={paginationProps}
                            loading={loadingTable}
                        />
                    </div>
                </>
            </Spin>
        </>
    );
}
